<template>
  <div class="lang-switch">
    <span 
      :class="{ active: currentLocale === 'zh' }" 
      @click="setLocale('zh')"
    >中文</span>
    <span class="separator">|</span>
    <span 
      :class="{ active: currentLocale === 'en' }" 
      @click="setLocale('en')"
    >EN</span>
  </div>
</template>

<script>
export default {
  name: 'LangSwitch',
  data() {
    return {
      currentLocale: this.$i18n.locale
    }
  },
  methods: {
    setLocale(lang) {
      // console.log('====== setLocale ======')
      // console.log('切换语言:', lang)
      
      // ⚠️ Vue 2 使用 this.$i18n
      this.$i18n.locale = lang
      this.currentLocale = lang
      
      try {
        localStorage.setItem('locale', lang)
      } catch (e) {
        console.warn('localStorage not available')
      }
      document.documentElement.lang = lang
      
      // console.log('this.$i18n.locale:', this.$i18n.locale)
      // console.log('this.$t("nav.home"):', this.$t('nav.home'))
      // console.log('===========================')
    }
  }
}
</script>

<style lang="scss" scoped>
.lang-switch {
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #bbb;
  span {
    padding: 0 0.5rem;
    transition: color 0.3s;
    &.active {
      color: #666;
      font-weight: 600;
    }
    &.separator {
      color: #ccc;
      padding: 0 0.25rem;
    }
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>